import PubSub from "pubsub-js";
import { isEmpty } from "underscore";

import { pubsubEvents } from "../../components/helpers/socket/pubsubEvent";
import {
  DELETE_BLOCK_FEED_FILTER_ACTION,
  GET_BLOCK_FEED_FILTERS_ACTION,
  UPDATE_BLOCK_FEED_FILTER_ACTION,
  CREATE_BLOCK_FEED_FILTER_ACTION,
} from "../../components/blockfeed/constants";

// import config from '../../components/helpers/socket/config'

const parseErrorPayload = (data, defaultMsg) => {
  if (!data) return defaultMsg;

  if (data.payload) {
    try {
      const parsed = JSON.parse(data.payload);
      if (parsed?.error) return parsed.error;
      if (parsed?.message) return parsed.message;
    } catch (e) {
      console.warn("Failed to parse error payload:", e);
      if (typeof data.payload === "string" && data.payload.trim() !== "") {
        return data.payload;
      }
    }
  }

  if (data.errors && data.errors.length > 0) {
    const errorStr = data.errors[0];
    try {
      const jsonMatch =
        typeof errorStr === "string" ? errorStr.match(/({.*})/) : null;
      if (jsonMatch && jsonMatch[0]) {
        const parsedInner = JSON.parse(jsonMatch[0]);
        if (parsedInner?.message) return parsedInner.message;
        if (parsedInner?.error) return parsedInner.error;
      }
    } catch (e) {
      console.warn("Failed to parse nested error JSON:", e);
    }
    return typeof errorStr === "string" && errorStr.trim() !== ""
      ? errorStr
      : defaultMsg;
  }

  return defaultMsg;
};

/**
 * This is the main handler for received socket
 * messages that can be shared across your
 * widget content sandbox.
 *
 * The switch statement is intended to
 * match received actions to a dispatch event.
 */

export function coreEventReciever(data) {
  if (data.status && (data.status === "ERROR" || data.status === "FAILURE")) {
    if (isEmpty(data.warnings)) {
      // PubSub.publish(config.eventKeys.DISPOSE_ANY_CARD_OVERLAYS, data)
      PubSub.publish(pubsubEvents.socketKeys.HANDLE_SOCKET_ERROR, data);
    }
    if (
      data.errors[0] !== pubsubEvents.errorMessage.REQUEST_ERROR_CMED_TIMEOUT &&
      data.errors[0] !==
        pubsubEvents.errorMessage.CMED_TOKEN_UNKNOWN_SQUARE_BRACKETS &&
      data.errors[0] !== pubsubEvents.errorMessage.CMED_TOKEN_UNKNOWN &&
      data.errors[0] !== pubsubEvents.errorMessage.ERROR_MESSAGE_GENERIC
    ) {
      switch (data.type) {
        case "blocks":
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors: "There was an issue loading block deals",
          });
          break;
        case "preference":
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors: "There was an issue while fetching user preferences.",
          });
          break;
        case "savepreferenceend":
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors:
              "There was an issue while saving user preferences. Please try again.",
          });
          break;

        case "getsavedfilter":
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors: "There was an issue while fetching saved filters.",
          });
          break;
        case "savecmedfilter":
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors:
              "There was an issue while saving the filter. Please try again.",
          });
          break;
        case "updatecmedfilter":
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors:
              "There was an issue while updating the filter. Please try again.",
          });
          break;
        case "deletecmedfilter":
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors:
              "There was an issue while deleting the filter. Please try again.",
          });
          break;
        case "trendSpiderChartUrl":
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors: data?.errors?.[0],
          });
          PubSub.publish(
            pubsubEvents.socketKeys.GET_TRENDSPIDER_CHART_URL_SUCCESS,
            data,
          );
          break;
        case GET_BLOCK_FEED_FILTERS_ACTION:
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors:
              "There was an issue while getting the filter. Please try again.",
          });
          break;
        case DELETE_BLOCK_FEED_FILTER_ACTION:
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors:
              "There was an issue while deleting the filter. Please try again.",
          });
          break;
        case UPDATE_BLOCK_FEED_FILTER_ACTION:
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors:
              "There was an issue while updating the filter. Please try again.",
          });
          break;
        case CREATE_BLOCK_FEED_FILTER_ACTION:
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors:
              "There was an issue while adding the filter. Please try again.",
          });
          break;
        case "startAlert":
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors: parseErrorPayload(
              data,
              "Failed to set the alert. Please try again.",
            ),
          });
          PubSub.publish(
            pubsubEvents.socketKeys.CORE_ALERT_START_FAILURE,
            data,
          );
          break;
        case "editAlert":
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors: parseErrorPayload(
              data,
              "Failed to edit the alert. Please try again.",
            ),
          });
          PubSub.publish(pubsubEvents.socketKeys.CORE_ALERT_EDIT_FAILURE, data);
          break;
        case "deleteAlert":
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors: parseErrorPayload(
              data,
              "Failed to delete the alert. Please try again.",
            ),
          });
          PubSub.publish(
            pubsubEvents.socketKeys.CORE_ALERT_DELETE_FAILURE,
            data,
          );
          break;
        case "pauseAlert":
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors: parseErrorPayload(
              data,
              "Failed to pause the alert. Please try again.",
            ),
          });
          PubSub.publish(
            pubsubEvents.socketKeys.CORE_ALERT_PAUSE_FAILURE,
            data,
          );
          break;
        case "resumeAlert":
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors: parseErrorPayload(
              data,
              "Failed to resume the alert. Please try again.",
            ),
          });
          PubSub.publish(
            pubsubEvents.socketKeys.CORE_ALERT_RESUME_FAILURE,
            data,
          );
          break;
        case "getFractionalType":
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors: parseErrorPayload(
              data,
              "Failed to fetch fractional type. Please try again.",
            ),
          });
          PubSub.publish(
            pubsubEvents.socketKeys.CORE_GET_FRACTIONAL_TYPE_FAILURE,
            data,
          );
          break;
        case "getAlerts":
          console.log("core:requested-alerts:update", data);
          PubSub.publish(
            pubsubEvents.socketKeys.CORE_REQUESTED_ALERTS_UPDATE,
            data,
          );
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors: parseErrorPayload(
              data,
              "Failed to fetch requested alerts. Please try again.",
            ),
          });
          break;
        case "getTriggeredAlerts":
          console.log("core:triggered-alerts:update", data);
          PubSub.publish(
            pubsubEvents.socketKeys.CORE_TRIGGERED_ALERTS_UPDATE,
            data,
          );
          PubSub.publish(pubsubEvents.errorKeys.CORE_ERROR_TOAST, {
            errors: parseErrorPayload(
              data,
              "Failed to fetch triggered alerts. Please try again.",
            ),
          });
          break;
        case "checkBeaconAccess":
          console.log(`❌ ${data.type}`);
          PubSub.publish(
            pubsubEvents.socketKeys.CHECK_BEACON_ACCESS_FAILURE,
            data,
          );
          break;
        default:
          console.log(`🔴 No matching error action found for ${data.type}`);
          break;
      }
    }
  } else {
    switch (data.type) {
      case "blocks":
        PubSub.publish(
          pubsubEvents.stompSubscriptionKeys.Block_FEED_HISTORICAL_DATA,
          data,
        );
        break;
      case "savePersistedOptionGrids":
        console.log("cmed:optionsgrid.save.data.to.db.success", data);
        PubSub.publish(
          pubsubEvents.socketKeys.CMED_OPTIONSGRID_SAVE_SUCCESS,
          data,
        );
        break;
      case "getPersistedOptionGrids":
        console.log("cmed:optionsgrid.fetch.data.from.db", data);
        PubSub.publish(pubsubEvents.socketKeys.CMED_OPTIONSGRID_FETCH, data);
        break;
      case "deletePersistedOptionGrids":
        console.log("cmed:optionsgrid.delete.data.from.db", data);
        PubSub.publish(pubsubEvents.socketKeys.CMED_OPTIONSGRID_DELETE, data);
        break;
      case "preference":
        console.log("user:preferences::success", data);
        PubSub.publish(pubsubEvents.socketKeys.PREFERENCES_SUCCESS, data);
        break;
      case "getFullName":
        console.log("user:getFullName::success", data);
        PubSub.publish(pubsubEvents.socketKeys.GET_FULL_NAME_SUCCESS, data);
        break;
      case "savepreferenceend":
        console.log("user:preferences::saved", data);
        PubSub.publish(pubsubEvents.socketKeys.SET_PREFERENCES, data);
        break;
      case "getsavedfilter":
        console.log("user:preferences::saved", data);
        PubSub.publish(pubsubEvents.socketKeys.GET_SAVED_CMEDFILTER, data);
        break;
      case "savecmedfilter":
        console.log("user:preferences::saved", data);
        PubSub.publish(pubsubEvents.socketKeys.SAVE_SAVED_CMEDFILTER, data);
        PubSub.publish(
          pubsubEvents.successKeys.TRADING_SERVICE_SUCCESS_TOAST,
          "Saved Filter Successfully!",
        );
        break;
      case "updatecmedfilter":
        console.log("user:preferences::saved", data);
        PubSub.publish(pubsubEvents.socketKeys.UPDATE_SAVED_CMEDFILTER, data);
        PubSub.publish(
          pubsubEvents.successKeys.TRADING_SERVICE_SUCCESS_TOAST,
          "Updated Filter Successfully!",
        );
        break;
      case "deletecmedfilter":
        console.log("user:preferences::saved", data);
        PubSub.publish(pubsubEvents.socketKeys.DELETE_SAVED_CMEDFILTER, data);
        PubSub.publish(
          pubsubEvents.successKeys.TRADING_SERVICE_SUCCESS_TOAST,
          "Deleted Filter Successfully!",
        );
        break;
      case "trendSpiderChartUrl":
        console.log(`✅ ${data.type}`);
        PubSub.publish(
          pubsubEvents.socketKeys.GET_TRENDSPIDER_CHART_URL_SUCCESS,
          data,
        );
        break;
      case GET_BLOCK_FEED_FILTERS_ACTION:
        console.log(`✅ ${data.type}`);
        PubSub.publish(pubsubEvents.socketKeys.GET_BLOCK_FILTER_SUCCESS, data);
        break;
      case DELETE_BLOCK_FEED_FILTER_ACTION:
        console.log(`✅ ${data.type}`);
        PubSub.publish(
          pubsubEvents.socketKeys.DELETE_BLOCK_FILTER_SUCCESS,
          data,
        );
        break;
      case UPDATE_BLOCK_FEED_FILTER_ACTION:
        console.log(`✅ ${data.type}`);
        PubSub.publish(
          pubsubEvents.socketKeys.UPDATE_BLOCK_FILTER_SUCCESS,
          data,
        );
        break;
      case CREATE_BLOCK_FEED_FILTER_ACTION:
        console.log(`✅ ${data.type}`);
        PubSub.publish(
          pubsubEvents.socketKeys.CREATE_BLOCK_FILTER_SUCCESS,
          data,
        );
        break;
      case "getAlerts":
        console.log("core:requested-alerts:update", data);
        PubSub.publish(
          pubsubEvents.socketKeys.CORE_REQUESTED_ALERTS_UPDATE,
          data,
        );
        break;
      case "getTriggeredAlerts":
        console.log("core:triggered-alerts:update", data);
        PubSub.publish(
          pubsubEvents.socketKeys.CORE_TRIGGERED_ALERTS_UPDATE,
          data,
        );
        break;
      case "startAlert":
        console.log("core:alert:start:success", data);
        PubSub.publish(pubsubEvents.socketKeys.CORE_ALERT_START_SUCCESS, data);
        // PubSub.publish(
        //   pubsubEvents.successKeys.TRADING_SERVICE_SUCCESS_TOAST,
        //   "Alert creation initiated...",
        // );
        break;
      case "editAlert":
        console.log("core:alert:edit:success", data);
        PubSub.publish(pubsubEvents.socketKeys.CORE_ALERT_EDIT_SUCCESS, data);
        // PubSub.publish(
        //   pubsubEvents.successKeys.TRADING_SERVICE_SUCCESS_TOAST,
        //   "Alert update initiated...",
        // );
        break;
      case "deleteAlert":
        console.log("core:alert:delete:success", data);
        PubSub.publish(pubsubEvents.socketKeys.CORE_ALERT_DELETE_SUCCESS, data);
        PubSub.publish(
          pubsubEvents.successKeys.TRADING_SERVICE_SUCCESS_TOAST,
          "Alert deleted successfully!",
        );
        break;
      case "pauseAlert":
        console.log("core:alert:pause:success", data);
        PubSub.publish(pubsubEvents.socketKeys.CORE_ALERT_PAUSE_SUCCESS, data);
        PubSub.publish(
          pubsubEvents.successKeys.TRADING_SERVICE_SUCCESS_TOAST,
          "Alert paused successfully!",
        );
        break;
      case "resumeAlert":
        console.log("core:alert:resume:success", data);
        PubSub.publish(pubsubEvents.socketKeys.CORE_ALERT_RESUME_SUCCESS, data);
        // PubSub.publish(
        //   pubsubEvents.successKeys.TRADING_SERVICE_SUCCESS_TOAST,
        //   "Alert resumed successfully!",
        // );
        break;
      case "getFractionalType":
        console.log("core:get.fractional.type:success", data);
        PubSub.publish(
          pubsubEvents.socketKeys.CORE_GET_FRACTIONAL_TYPE_SUCCESS,
          data,
        );
        break;
      case "checkBeaconAccess":
        console.log(`✅ ${data.type}`);
        PubSub.publish(
          pubsubEvents.socketKeys.CHECK_BEACON_ACCESS_SUCCESS,
          data,
        );
        break;

      default:
        console.log(`🔴 No matching action found for ${data.type}`);
        break;
    }
  }
  console.groupEnd();
}
